<template>
  <div :class="['sidebar', sidebarClass]">
    <!-- زر الإغلاق للموبايل -->
    <button class="btn-close d-md-none" @click="closeSidebar">×</button>

    <h5 class="sidebar-title">لوحة العميل</h5>
    <ul class="custom-sidebar-list">
      <li class="nav-item" v-for="link in links" :key="link.name">
        <router-link
          :to="link.to"
          class="nav-link"
          :class="{ 'active-link': $route.path === link.to }"
          @click="closeSidebar"
        >
          <i :class="link.icon" class="icon-right"></i>
          <span class="link-text">{{ link.name }}</span>
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "ClientSidebar",
  props: {
    isOpen: Boolean,
  },
  data() {
    return {
      screenWidth: window.innerWidth,
      links: [
        { name: "الرئيسية", to: "/client", icon: "bi bi-house-door" },
        { name: "الأقسام", to: "/client/sections", icon: "bi bi-folder" },
        { name: "الأصناف", to: "/client/items", icon: "bi bi-basket" },
        {
          name: "تفاصيل الاشتراك",
          to: "/client/subscription",
          icon: "bi bi-info-circle",
        },
        { name: "الإعدادات", to: "/client/settings", icon: "bi bi-gear" },
        { name: "حول", to: "/client/about", icon: "bi bi-question-circle" },
      ],
    };
  },
  computed: {
    sidebarClass() {
      if (this.screenWidth >= 960) return "sidebar-open";
      return this.isOpen ? "sidebar-open" : "sidebar-closed";
    },
  },
  mounted() {
    window.addEventListener("resize", this.updateWidth);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.updateWidth);
  },
  methods: {
    updateWidth() {
      this.screenWidth = window.innerWidth;
    },
    closeSidebar() {
      if (this.screenWidth < 960) {
        this.$emit("toggle-sidebar", false);
      }
    },
  },
};
</script>

<style scoped>
.sidebar {
  background-color: #343a40;
  color: white;
  padding: 5px 10px 10px 10px;
  width: 220px;
  height: 100vh;
  position: fixed;
  right: 0;
  top: 0;
  bottom: 50px;
  overflow-y: auto;
  transition: transform 0.3s ease-in-out;
  z-index: 1050;
}

.sidebar-open {
  transform: translateX(0);
}
.sidebar-closed {
  transform: translateX(100%);
}

.btn-close {
  background: none;
  border: none;
  color: white;
  font-size: 1.5rem;
  margin-bottom: 10px;
  display: block;
}

.sidebar-title {
  font-size: 1rem;
  margin-bottom: 10px;
  margin-top: 5px;
  color: #ffffffcc;
  font-weight: bold;
}

.custom-sidebar-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.custom-sidebar-list .nav-item {
  margin-bottom: 4px;
}

.nav-link {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 8px 12px;
  text-decoration: none;
  color: #ffffffcc;
  border-radius: 5px;
  transition: background-color 0.2s ease;
}

.nav-link:hover {
  background-color: #0d6efd;
  color: white !important;
}

.icon-right {
  margin-left: 10px;
  font-size: 1.2rem;
}

.link-text {
  flex: 1;
  text-align: center;
}

.active-link {
  background-color: #0d6efd;
  color: #fff !important;
  font-weight: bold;
  box-shadow: 0 0 5px rgba(13, 110, 253, 0.6);
}
</style>
